import React from 'react';
import { CalendarCheckIcon, BookOpenIcon, ClipboardCheckIcon, BoxIcon } from 'lucide-react';
interface Bono {
  tag: string;
  title: string;
  desc: string;
  Icon: BoxIcon;
}
export function Bonos() {
  const bonos: Bono[] = [{
    tag: 'Bono 1',
    title: 'Guía de implementación en 7 días',
    desc: 'Qué hacer exactamente cada día durante una semana para que al final del domingo tu consultorio tenga los protocolos más importantes funcionando. Una tarea por día, máximo 45 minutos.',
    Icon: CalendarCheckIcon
  }, {
    tag: 'Bono 2',
    title: 'Manual del asistente dental',
    desc: 'El manual que tu asistente debería haber recibido el primer día de trabajo y que en la mayoría de los consultorios nunca existe. Imprimíselo y entregáselo — que sepa exactamente qué se espera de él.',
    Icon: BookOpenIcon
  }, {
    tag: 'Bono 3',
    title: 'Auditoría express del consultorio',
    desc: '40 preguntas en 6 áreas para saber exactamente en qué punto está tu consultorio hoy — y qué atacar primero. Completala en 20 minutos. Al final sabés por dónde empezar.',
    Icon: ClipboardCheckIcon
  }];
  return <section className="bg-navy px-5 py-10 md:py-[70px] text-center" data-id="element-16">
      <div className="mx-auto max-w-[1000px]" data-id="element-17">
        <p className="mb-3 font-montserrat text-[11px] font-extrabold uppercase tracking-[3px] text-brandRed" data-id="element-18">
          Incluidos gratis
        </p>
        <h2 className="mb-2 font-bebas text-[clamp(30px,5vw,52px)] text-white" data-id="element-19">
          3 Bonos Estratégicos
        </h2>
        <p className="mb-6 md:mb-[44px] text-[15px] text-white/60" data-id="element-20">
          Sin costo extra — incluidos en todas las ofertas
        </p>

        <div className="mb-6 md:mb-[36px] grid grid-cols-1 gap-4 sm:grid-cols-3" data-id="element-21">
          {bonos.map((bono, i) => <div key={i} className="flex flex-col rounded-[10px] border border-white/10 bg-white/5 p-5 text-left" data-id="element-22">
              <div className="mb-3 flex items-center gap-3" data-id="element-23">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-gold/15 text-gold" data-id="element-24">
                  <bono.Icon className="h-5 w-5" strokeWidth={2} aria-hidden="true" data-id="element-25" />
                </span>
                <span className="flex items-center gap-2 font-montserrat text-[10px] font-extrabold uppercase tracking-[2px] text-gold" data-id="element-26">
                  {bono.tag}
                  <span className="rounded-[3px] bg-gold px-2 py-0.5 text-[9px] text-navy" data-id="element-27">
                    GRATIS
                  </span>
                </span>
              </div>
              <p className="mb-2 font-montserrat text-[14px] font-extrabold text-white" data-id="element-28">
                {bono.title}
              </p>
              <p className="text-[13px] leading-relaxed text-white/55" data-id="element-29">
                {bono.desc}
              </p>
            </div>)}
        </div>

        <p className="font-montserrat text-[16px] font-extrabold text-gold" data-id="element-30">
          VALOR TOTAL DE LOS BONOS: $24.000 — GRATIS
        </p>
      </div>
    </section>;
}